<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">任务规划量</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <!-- <p>人均实际完成point，计算任务完成时间在 “时间”区间内的完成总point/(总人数*总时间),其中总时间不过滤节假日以及请假</p> -->
            <p>人均计划完成point，计算任务计划完成时间在 “对比时间”区间内的计划完成总point/(总人数*总时间),其中总时间过滤节假日以及请假</p>
            <p>人均待办point，计算任务计划完成时间在 “对比时间”区间内的且任务状态为“待开始”或“开发中”的总point/总人数</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <!-- <div slot="extra">
        <a-radio-group v-model="showModal" button-style="solid" size="small" @change="getTaskPointRank">
          <a-radio-button value="team"> 团队 </a-radio-button>
          <a-radio-button value="person"> 个人 </a-radio-button>
        </a-radio-group>
      </div> -->
      <div id="task-plan-done" :style="{ height: height, width: width }" />
    </a-card>
  </div>
</template>
<script>
import { getTaskTrend } from '@/api/data/task';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'team',
      loading: true,
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            name: '人均每日代办任务点',
            axisTick: {
              show: false
            }
          },
          {
            type: 'value',
            name: '人均待办总任务点',
            axisTick: {
              show: false
            }
          }
        ],
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      data: []
    };
  },

  watch: {
    filterForm() {
      this.getTaskPointRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  created() {
    this.getTaskPointRank();
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById('task-plan-done'));
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getTaskPointRank() {
      this.loading = true;
      getTaskTrend({ ...this.filterForm })
        .then(res => {
          this.data = res.data;
          // this.data = res.data.items;
          const x_axis = res.data.xList;
          const done_point = res.data.yList1;
          const plan_point = res.data.yList2;
          const todo_point = res.data.yList3;
          this.option.xAxis.data = x_axis;
          this.option.series = [
            // {
            //   type: 'bar',
            //   label: {
            //     show: true,
            //     position: 'top'
            //   },
            //   name: '人均实际每日完成point',
            //   data: done_point
            // },
            {
              type: 'bar',

              label: {
                show: true,
                position: 'top'
              },
              name: '人均计划每日完成任务点',
              data: done_point
            },
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '人均待办总任务点',
              data: todo_point,
              yAxisIndex: 1
            }
          ];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
</style>
